import { Layout, Menu } from 'antd'
import { useState } from 'react'
import CasesExplorer from './Cases/CasesExplorer'
import GoldenPromptsExplorer from './GoldenPrompts/GoldenPromptsExplorer'
import McpMocksExplorer from './McpMocks/McpMocksExplorer'
import PresetsExplorer from './Presets/PresetsExplorer'
import RatingsExplorer from './Ratings/RatingsExplorer'
import RubricsExplorer from './Rubrics/RubricsExplorer'
import RunsExplorer from './Runs/RunsExplorer'
import TagsExplorer from './Tags/TagsExplorer'
import './EvalSection.css'

const { Sider, Content } = Layout

type EvalView =
  | 'ratings'
  | 'golden-prompts'
  | 'mcp-mocks'
  | 'rubrics'
  | 'cases'
  | 'tags'
  | 'runs'
  | 'presets'

const EvalSection = () => {
  const [view, setView] = useState<EvalView>('ratings')

  return (
    <Layout className="eval-section">
      <Sider width={220} className="eval-sider">
        <Menu
          mode="inline"
          selectedKeys={[view]}
          onClick={({ key }) => setView(key as EvalView)}
          items={[
            { key: 'ratings', label: 'Ratings' },
            { key: 'golden-prompts', label: 'Golden Prompts' },
            { key: 'mcp-mocks', label: 'MCP Mocks' },
            { key: 'rubrics', label: 'Rubrics' },
            { key: 'cases', label: 'Cases' },
            { key: 'tags', label: 'Tags' },
            { key: 'runs', label: 'Runs' },
            { key: 'presets', label: 'Presets' },
          ]}
        />
      </Sider>
      <Content className="eval-content">
        {view === 'ratings' && <RatingsExplorer />}
        {view === 'golden-prompts' && <GoldenPromptsExplorer />}
        {view === 'mcp-mocks' && <McpMocksExplorer />}
        {view === 'rubrics' && <RubricsExplorer />}
        {view === 'cases' && <CasesExplorer />}
        {view === 'tags' && <TagsExplorer />}
        {view === 'runs' && <RunsExplorer />}
        {view === 'presets' && <PresetsExplorer />}
      </Content>
    </Layout>
  )
}

export default EvalSection
